import { useEffect } from 'react';

/**
 * Replacement for class-based componentWillUnmount lifecycle hook.
 * Allows you to invoke a function when the component is about to unmount.
 * Note: the function can be async, although should not reference variables or nodes
 * which are about to be removed from the DOM.
 *
 * @param {() => void} onUnmount - Function to be invoked when the component mounts.
 */
const useOnUnmount = (onUnmount: () => void) => {
  useEffect(() => () => {
    onUnmount();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useOnUnmount;
